import { alpha, createTheme, ThemeOptions } from '@mui/material';

const partialTheme = createTheme({
	breakpoints: {
		values: {
			xs: 0,
			sm: 601,
			md: 961,
			lg: 1367,
			xl: 1537,
		},
	},
	palette: {
		primary: {
			main: '#1774FE',
			contrastText: '#FFFFFF',
		},
		secondary: {
			main: '#FEC123',
			contrastText: '#FFFFFF',
		},
		text: {
			primary: '#000000', //Body text
			secondary: '#252f35', //Dark,
			disabled: '#8F8F8F',
		},
		background: {
			default: '#FFFFFF',
		},
		highlighted: {
			primary: '#FFFAED',
			secondary: '#F9F9F9',
			disabled: '#000000',
		},
		green: {
			main: '#18A900',
			light: '',
			dark: '',
			contrastText: '',
		},
		borders: {
			primary: '#D9D9D9',
			secondary: '#D9D9D9',
			disabled: '#D9D9D9',
		},
		error: {
			main: '#bb2828',
			light: '#FF0000',
		},
		blue: {
			main: '#1774fe',
			light: '',
			dark: 'rgba(23, 116, 254, 0.8)',
			contrastText: '#FFFFFF',
		},
		header: {
			main: '#ffffff',
			light: '',
			dark: '#FEC123',
			contrastText: '#635533',
		},
		footer: {
			main: '#fffaed',
			light: '',
			dark: '#FEC123',
			contrastText: '#635533',
		},
		inactive: {
			main: '#D9D9D9',
			light: '#BEBEBE',
		},
		filterButton: {
			main: '#ECEFF3',
		},
	},
	components: {
		MuiButton: {
			styleOverrides: {
				containedPrimary: ({ theme }) => ({
					':hover': { backgroundColor: alpha(theme.palette.primary.main, 0.8) },
					'&:disabled': {
						backgroundColor: alpha(theme.palette.primary.main, 0.4),
						color: theme.palette.primary.contrastText,
					},
				}),
				outlinedPrimary: ({ theme }) => ({
					':hover': { backgroundColor: alpha(theme.palette.primary.main, 0.2) },
					borderColor: theme.palette.primary.main,
				}),
				contained: ({ theme, ownerState: { color } }) => ({
					'&:disabled': {
						backgroundColor: alpha(
							theme.palette[color && color !== 'inherit' ? color : 'primary']?.main ??
								theme.palette.primary.main,
							0.4
						),
						color: theme.palette[color && color !== 'inherit' ? color : 'primary']?.contrastText,
					},
				}),
			},
		},
		MuiFormLabel: {
			styleOverrides: {
				asterisk: ({ theme }) => ({
					color: theme.palette?.error.main,
					fontSize: theme.typography.h5.fontSize,
					lineHeight: theme.typography.h5.lineHeight,
				}),
			},
		},
		MuiFormControlLabel: {
			styleOverrides: {
				asterisk: ({ theme }) => ({
					color: theme.palette?.error.main,
					fontSize: theme.typography.h5.fontSize,
					lineHeight: theme.typography.h5.lineHeight,
				}),
			},
		},
	},
});

export const theme: ThemeOptions = {
	...partialTheme,
	typography: {
		fontFamily: 'Roboto, Noto Sans, sans-serif',
		h1: {
			fontSize: '3.625rem',
			lineHeight: '4.938rem',
			[partialTheme.breakpoints.down('sm')]: {
				fontSize: '1.375rem',
				lineHeight: '1.875rem',
			},
		},
		h2: {
			fontSize: '2.25rem',
			lineHeight: '3.063rem',
			[partialTheme.breakpoints.down('sm')]: {
				fontSize: '1.25rem',
				lineHeight: '1.563rem',
			},
		},
		h3: {
			fontSize: '1.75rem',
			lineHeight: '2.75rem',
			[partialTheme.breakpoints.down('sm')]: {
				fontSize: '1.12rem',
				lineHeight: '1.5rem',
			},
		},
		h4: {
			fontSize: '1.25rem',
			lineHeight: '1.688rem',
			[partialTheme.breakpoints.down('sm')]: {
				fontSize: '1rem',
				lineHeight: '1.375rem',
			},
		},
		body1: {
			fontSize: '1rem',
			lineHeight: '1.375rem',
			[partialTheme.breakpoints.down('sm')]: {
				fontSize: '0.875rem',
				lineHeight: '1.5rem',
			},
		},
		h5: {
			fontSize: '0.875rem',
			lineHeight: '1.188rem',
			[partialTheme.breakpoints.down('sm')]: {
				fontSize: '0.75rem',
				lineHeight: '1rem',
			},
		},
	},
};
